/* eslint-env browser */

/**
 * Hamburger menu implementation
 */

(function () {
    var hamburgerButton = $('.menu-toggler');
    var closeButton = $('.close-menu');
    var menu = $('.navigation');

    var openMenu = function () {
        $(menu).show();
    }

    var closeMenu = function () {
        $(menu).hide();
    }

    $(hamburgerButton).click(openMenu);
    $(closeButton).click(closeMenu);
})();
